























import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { Balance as IBalance } from "@foxone/api/src/models/hfox";
import SetReceivingWalletAction from "./SetReceivingWalletAction.vue";
import { USDT_ASSET } from "hfox/constants";

@Component({
  components: {
    SetReceivingWalletAction
  }
})
class Balance extends Vue {
  @State(state => state.hfox.balance) balance!: IBalance;

  get meta() {
    const toFiat = this.$common.utils.currency.fiat;
    const balance = this.balance?.balance;
    const balanceText = `${balance} ${USDT_ASSET.symbol}`;
    const balanceFiatText = toFiat(this, {
      value: balance,
      from: USDT_ASSET.symbol
    });
    return {
      balanceText,
      balanceFiatText
    };
  }

  handleCheckBalance() {
    this.$helper.toFusionPath(this, "hfox", { name: "check_balance" });
  }
}
export default Balance;
